<ng-container *transloco="let t">
  <app-page-template [displayLargeMobileFooter]="false">
    <div class="container">
      <div class="pt-120-60 pb-300-100">
        @if (signupComponentState === SignupComponentState.SUCCESS) {
          <section class="upper-section py-5 px-4">
            <div class="upper-section-background image-fade-in" [@fadeInAnimation]="'in'"></div>
            <div class="d-block d-md-flex justify-content-center align-items-center">
              <div>
                <app-form-card>
                  <ng-container>
                    <app-alert-success/>
                    <h4 class="text-center">{{
                        t('signup.result.success.info.verify.1') + " " +
                        (((inputForm.controls.email.value?.length ?? 0) > 0) ? inputForm.controls.email.value :
                          t('signup.result.success.info.verify.3'))
                      }}</h4>
                    <p class="text-center pt-3">{{t('signup.result.success.info.verify.2')}}</p>
                    <div class="text-center separator mt-2">
                      <span class="fs-13-px">{{t('signup.result.success.info.retry')}}</span>
                      <span class="link-button ps-1 fw-bold fs-13-px" (click)="setInitialState()">{{
                          t('signup.result.success.info.retry.button')
                        }}</span>
                    </div>
                    <div class="separator my-5"></div>
                    <app-button [label]="t('signup.verification.go.to.login')" [btnClass]="'btn-primary-red btn-large'"
                                (onClick)="toLogin()"/>
                  </ng-container>
                </app-form-card>
              </div>
            </div>
          </section>
        } @else {
          <app-grey-card-with-title [title]="t('signup.create.your.free.account')" [removeContentPaddingTop]="true">
            <div class="pb-20 pt-20">
              <p class="regular d-inline">{{t('signup.already.have.an.account')}}</p>
              <p class="regular cursor-pointer ps-2 underline-link d-inline" (click)="toLogin()">{{
                  t('app.common.login')
                }}</p>
            </div>

            <div class="pt-16">
              <form #signUp="ngForm" [formGroup]="inputForm">
                <div class="row">
                  <div class="col-lg-6 col-12">
                    <app-input formControlName="firstName" label="app.common.first.name"/>
                  </div>
                  <div class="col-lg-6 col-12 pt-2 pt-lg-0">
                    <app-input formControlName="lastName" label="app.common.last.name"/>
                  </div>
                </div>
                <div class="pt-20-10">
                  <app-input type="password" formControlName="password" label="app.common.password"
                             [hideErrorMessage]="true"/>
                  @if (inputForm.controls.password.touched && inputForm.controls.password.errors) {
                    @if (inputForm.controls.password.errors['required']) {
                      <div class="errorMes pt-1">
                        {{t('app.common.error.required')}}
                      </div>
                    } @else {
                      <div class="errorMes pt-1">
                        {{t("app.common.error.password.prefix")}}:
                      </div>
                      @for (errorMessage of inputForm.controls.password.errors | errorMessages:'password':true;track
                        errorMessage) {
                        <div class="errorMes pt-1">
                          <div class="ps-3 d-inline-flex">
                            <i class="bi bi-dot"></i>
                            {{errorMessage}}
                          </div>
                        </div>
                      }
                    }
                  }
                </div>
                <div class="pt-20-10">
                  <app-input formControlName="email" label="app.common.email"/>
                </div>
                <div class="pt-20-10">
                  <app-select formControlName="gender" [items]="genders" labelKeyPrefix="app.common.gender."
                              label="app.common.gender" labelKey="id" valueKey="id"/>
                </div>
                <div class="pt-30-28 d-flex">
                   <div (click)="openConsentModal()">
                        <input class="form-check-input" type="checkbox" id="termsAndConditions"
                        [class.ng-invalid]="inputForm.controls.termsAndConditionsAccepted.touched &&!inputForm.controls.termsAndConditionsAccepted.valid"
                         formControlName="termsAndConditionsAccepted"/>
                    </div>

                  <p class="small ps-2">
                    <a class="text-decoration-underline cursor-pointer" (click)="openConsentModal(true)" [class.error]="inputForm.controls.termsAndConditionsAccepted.touched &&!inputForm.controls.termsAndConditionsAccepted.valid">
                        {{t("app.common.accept.conditions")}}
                    </a>
                  </p>
                </div>
                @if (signupComponentState === SignupComponentState.ERROR) {
                  <div class="pt-4">
                    <span class="error-message">{{t('signup.error.' + signupComponentError)}}</span>
                  </div>
                }
                <div class="pt-20-10 mt-30">
                  <app-button-alt [textColor]="'white'"
                                  [text]="t('app.common.signup')"
                                  (onClickCallback)="onRegister()" [isFullWidth]="true"></app-button-alt>
                </div>
                <app-section-divider/>
                <div class="row">
                  <div class="col-12">
                    <app-google-signin-button/>
                  </div>
                </div>
              </form>
            </div>
          </app-grey-card-with-title>
        }
      </div>
    </div>
  </app-page-template>
</ng-container>
